import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@deepguide-ai/ui/select'
import { ShieldCheck } from 'lucide-react'
import { FilterPill } from '@/components/ui/filter-pill'
import type { RiskTierFilter, StatusFilter } from './type'

export function VendorFilters({
  riskTier,
  status,
  onRiskTierChange,
  onStatusChange,
  includeOffboarded = false,
}: {
  riskTier: RiskTierFilter
  status: StatusFilter
  onRiskTierChange: (value: RiskTierFilter) => void
  onStatusChange: (value: StatusFilter) => void
  includeOffboarded?: boolean
}) {
  return (
    <div className='flex flex-wrap items-center gap-2'>
      <div className='flex items-center gap-1'>
        <ShieldCheck className='text-text-subtle h-4 w-4' />
        <span className='font-body text-muted-foreground text-[12px]'>
          Risk:
        </span>
      </div>
      {(
        [
          { value: 'all', label: 'All' },
          {
            value: 'CRITICAL',
            label: 'Critical',
            color: 'bg-status-red text-white',
          },
          { value: 'HIGH', label: 'High', color: 'bg-status-red text-white' },
          {
            value: 'MEDIUM',
            label: 'Medium',
            color: 'bg-status-orange text-white',
          },
          { value: 'LOW', label: 'Low', color: 'bg-status-green text-white' },
        ] as const
      ).map((t) => (
        <FilterPill
          key={t.value}
          active={riskTier === t.value}
          onClick={() => onRiskTierChange(t.value)}
          lightActiveClassName={'color' in t ? t.color : undefined}
        >
          {t.label}
        </FilterPill>
      ))}

      <div className='bg-border mx-1 h-5 w-px' />

      <Select
        value={status}
        onValueChange={(v) => onStatusChange(v as StatusFilter)}
      >
        <SelectTrigger
          aria-label='Vendor status'
          className='font-body border-border-divider bg-card text-muted-foreground h-8 w-[140px] rounded-sm border px-3 text-[12px] font-medium'
        >
          <SelectValue placeholder='Status' />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value='all'>All Statuses</SelectItem>
          <SelectItem value='ACTIVE'>Active</SelectItem>
          <SelectItem value='UNDER_REVIEW'>Under Review</SelectItem>
          <SelectItem value='PENDING_ONBOARDING'>Pending</SelectItem>
          {includeOffboarded && (
            <SelectItem value='OFFBOARDED'>Offboarded</SelectItem>
          )}
        </SelectContent>
      </Select>
    </div>
  )
}
